import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Configuração Biblioteca',
        path: '/biblioteca/bibconfiguracao',
        name: 'bibconfiguracao',
        component: () => import('@/views/biblioteca/bibconfiguracao/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CONFIGURACAOBIBLIOTECANOVO_MENU_1300801999],
        },
        goesToMenu: true,
    },

]
